"use client"

import { useTheme } from "next-themes"
import { Toaster as Sonner, type ToasterProps } from "sonner"

const Toaster = ({ theme, ...props }: ToasterProps) => {
  const { resolvedTheme } = useTheme()

  // Se il tema è "system", segue il tema dell'app (next-themes).
  // Se è "light"/"dark", viene rispettata la scelta esplicita.
  const resolvedToastTheme =
    theme === "system" || theme === undefined
      ? (resolvedTheme as "light" | "dark")
      : theme

  return (
    <Sonner
      theme={resolvedToastTheme}
      className="toaster group"
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-border": "var(--border)",
          "--normal-text": "var(--popover-foreground)",
          "--description-color": "var(--muted-foreground)",
          "--action-button-color": "var(--primary)",
          "--cancel-button-color": "var(--muted-foreground)",
          "--error-bg": "var(--destructive)",
          "--error-text": "var(--destructive-foreground)",
        } as React.CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster }
